import SafeIcon from '../common/SafeIcon';
import { FiFilm, FiGithub, FiMoon, FiSun, FiUser } from 'react-icons/fi';

interface HeaderProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

const Header = ({ darkMode, setDarkMode }: HeaderProps) => (
  <header className="w-full py-5 px-4 md:px-8">
    <div className="max-w-5xl mx-auto flex justify-between items-center">
      <a href="/" aria-label="VidBatch - Free Batch Video Converter" className="flex items-center gap-3 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950" translate="no">
        <div className="bg-gradient-to-br from-teal-600 to-lime-500 p-2.5 rounded-2xl text-white shadow-lg shadow-teal-500/30">
          <SafeIcon icon={FiFilm} className="text-xl" />
        </div>
        <div>
          <p className="text-xl font-black tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-teal-700 to-lime-600 dark:from-teal-300 dark:to-lime-300 leading-none">
            VidBatch
          </p>
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mt-0.5">
            Free Batch Video Converter
          </p>
        </div>
      </a>

      <nav className="flex items-center gap-2" aria-label="Primary">
        <a
          href="https://github.com/trevonerd/vidbatch"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="VidBatch repository on GitHub"
          title="Repository"
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
        >
          <SafeIcon icon={FiGithub} className="text-xl" />
        </a>
        <a
          href="https://github.com/trevonerd"
          target="_blank"
          rel="me noopener noreferrer"
          aria-label="trevonerd GitHub profile"
          title="Profile"
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
        >
          <SafeIcon icon={FiUser} className="text-xl" />
        </a>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          title={darkMode ? 'Light mode' : 'Dark mode'}
        >
          {darkMode
            ? <SafeIcon icon={FiSun} className="text-xl text-amber-400" />
            : <SafeIcon icon={FiMoon} className="text-xl text-slate-600" />}
        </button>
      </nav>
    </div>
  </header>
);

export default Header;
